import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

export default function NewsDetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/news/${slug}`).then((res) => setItem(res.data)).catch(() => setItem(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0A2A43]"></div></div>;
  if (!item) return <div className="section-padding text-center" data-testid="news-detail-missing"><p className="text-gray-500 mb-4">News-Beitrag nicht gefunden.</p><Link to="/news" className="btn-primary">Zurück zur Übersicht</Link></div>;

  return (
    <div data-testid="news-detail-page">
      <section className="section-padding bg-white">
        <div className="max-w-4xl mx-auto">
          <Link to="/news" className="inline-flex items-center text-[#D32F2F] font-semibold mb-6" data-testid="news-back-link">← Zurück zu News</Link>
          <p className="text-sm text-[#D32F2F] mb-3">{new Date(item.date).toLocaleDateString("de-DE")}</p>
          <h1 className="text-4xl font-bold text-[#0A2A43] font-barlow mb-6">{item.title}</h1>
          {item.image_url && <img src={item.image_url} alt={item.title} className="w-full rounded-xl mb-8 max-h-[520px] object-cover" />}
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-[#475569] mb-6">{item.short_text}</p>
            <div className="text-[#334155] whitespace-pre-wrap leading-8">{item.full_text}</div>
          </div>
        </div>
      </section>
    </div>
  );
}
